import { ORG_CACHE_SEP } from "./orgCacheStorage";

export const ACTIVE_SESSION_KEY = "CP_ACTIVE_SESSION";

export function buildActiveSessionCacheKey(supabaseUserId) {
  if (!supabaseUserId) {
    return null;
  }

  return `${ACTIVE_SESSION_KEY}${ORG_CACHE_SEP}${supabaseUserId}`;
}

function readJson(key) {
  if (!key) {
    return null;
  }

  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

function migrateLegacyActiveSession(supabaseUserId) {
  const legacyRaw = localStorage.getItem(ACTIVE_SESSION_KEY);
  if (!legacyRaw) {
    return null;
  }

  try {
    const session = JSON.parse(legacyRaw);
    if (session?.supabase_user_id !== supabaseUserId) {
      return null;
    }

    const scopedKey = buildActiveSessionCacheKey(supabaseUserId);
    localStorage.setItem(scopedKey, legacyRaw);
    localStorage.removeItem(ACTIVE_SESSION_KEY);
    return session;
  } catch {
    localStorage.removeItem(ACTIVE_SESSION_KEY);
    return null;
  }
}

function readStoredSessionForUser(supabaseUserId) {
  const scopedKey = buildActiveSessionCacheKey(supabaseUserId);
  if (!scopedKey) {
    return null;
  }

  const scopedSession = readJson(scopedKey);
  if (scopedSession) {
    return scopedSession;
  }

  return migrateLegacyActiveSession(supabaseUserId);
}

/**
 * Read the locally mirrored active session for the authenticated user.
 */
export function getLocalActiveSession(supabaseUserId = null) {
  if (!supabaseUserId) {
    return null;
  }

  const session = readStoredSessionForUser(supabaseUserId);
  if (!session) {
    return null;
  }

  if (
    session.supabase_user_id &&
    session.supabase_user_id !== supabaseUserId
  ) {
    clearLocalActiveSession(supabaseUserId);
    return null;
  }

  return session;
}

export function saveLocalActiveSession(session, supabaseUserId = null) {
  const userId = supabaseUserId ?? session?.supabase_user_id;
  const scopedKey = buildActiveSessionCacheKey(userId);

  if (!scopedKey || !session) {
    return;
  }

  localStorage.setItem(
    scopedKey,
    JSON.stringify({
      ...session,
      supabase_user_id: userId,
    }),
  );
}

export function clearLocalActiveSession(supabaseUserId = null) {
  const scopedKey = buildActiveSessionCacheKey(supabaseUserId);
  if (scopedKey) {
    localStorage.removeItem(scopedKey);
  }
}
